import { AppTheme } from "../../theme"


export const createMapStyles = (theme: AppTheme) => ({
    
    tabs: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        alignContent: "center",
        gap:"8px",
        p: "8px 12px",
        height: "56px",
        borderRadius: "10px",
        backgroundColor: theme.palette.neutral_5,
        boxShadow: "0px 1.13px 3.39px 1.13px #00000026, 0px 0.56px 1.13px 0px #0000004D"
    },
    tabButton: {
        height: "40px", 
        minWidth:"130px", 
        display: "flex", 
        alignItems:"center", 
        justifyContent: "center",
        borderRadius: "6px",
        color: theme.palette.neutral_0,
        '&.Mui-disabled': {
            backgroundColor: theme.palette.neutral_5
        }
    },
    tabSelected: {
        backgroundColor: theme.palette.tertiary.main, 
        color: theme.palette.neutral_5
    },
    floatIconButton: {
        display: "flex",
        backgroundColor: theme.palette.neutral_5,
        borderRadius: '8px',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.neutral_5,
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.neutral_5
        },
        'MuiTouchRipple-root': { display: 'none' }
    }
})

